import { useRef, useState, useEffect } from "react";
import NewPopup from "../../../../../../../GlobalComponents/Popup/NewPopup";
import { Actions } from "../../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../../Utils/storeUtils";
import ImageUploader from "../../../../../../../GlobalComponents/ImageUploader/ImageUploader";

const EditSiteImage = (props) => {
  const {
    popupCard,
    image,
    setPopupCard,
    loading,
    siteName,
    setLoading,
    siteId,
  } = props;

  const fileInputRef = useRef(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [img, setImg] = useState(image || null);
  const [isUpload, setIsUpload] = useState(true);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (uploadFile) {
      const imageUrl = URL.createObjectURL(uploadFile);
      setImg(imageUrl);
      setIsUpload(false);
    }
  }, [uploadFile]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadFile(file);
    }
  };

  const siteUploadImage = () => {
    if (!uploadFile) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("siteName", siteName);

    const uploadId = Date.now();
    getStore().dispatch({
      type: Actions.API_SITE_IMAGE,
      data: formData,
      meta: {
        uploadId,
        onSuccess: () => {
          getStore().dispatch({
            type: Actions.API_GET_SELECTED_SITE_DETAILS,
            data: {
              siteId: siteId,
            },
            meta: {
              onSuccess: (data) => {
                const selectedEnvData = data.stagingDomainsList.find(
                  (list) => list.environment === "LIVE"
                );
                getStore().dispatch({
                  type: Actions.SET_SELECTED_DOMAIN,
                  data: selectedEnvData,
                });
              },
              onError: () => {},
            },
          });
          getStore().dispatch({
            type: Actions.SET_ALL_SITES,
          });
          setPopupCard(false);
          setLoading(false);
        },
        onError: () => {
          getStore().dispatch({
            type: Actions.API_GET_SELECTED_SITE_DETAILS,
            data: {
              siteId: siteId,
            },
            meta: {
              onSuccess: (data) => {
                const selectedEnvData = data.stagingDomainsList.find(
                  (list) => list.environment === "LIVE"
                );
                getStore().dispatch({
                  type: Actions.SET_SELECTED_DOMAIN,
                  data: selectedEnvData,
                });
              },
              onError: () => {},
            },
          });
          getStore().dispatch({
            type: Actions.SET_ALL_SITES,
          });
          setPopupCard(false);
          setLoading(false);
        },
      },
    });
  };
  const siteDeleteImage = () => {
    setDeleting(true);
    getStore().dispatch({
      type: Actions.API_REMOVE_SITE_IMAGE,
      data: { siteName: siteName },
      meta: {
        onSuccess: () => {
          setImg(null);
          getStore().dispatch({
            type: Actions.API_GET_SELECTED_SITE_DETAILS,
            data: { siteId },
            meta: {
              onSuccess: (data) => {
                const selectedEnvData = data.stagingDomainsList.find(
                  (list) => list.environment === "LIVE"
                );
                getStore().dispatch({
                  type: Actions.SET_SELECTED_DOMAIN,
                  data: selectedEnvData,
                });
              },
              onError: () => {},
            },
          });
          setPopupCard(false);
          setDeleting(false);
          setLoading(false);
        },
        onError: () => {
          setPopupCard(false);
          setDeleting(false);
          setLoading(false);
        },
      },
    });
  };

  const handleClosePopup = () => {
    setPopupCard(false);

    if (!uploadFile) {
      setImg(image || null);
    } else {
      setImg(image || null);
    }

    setUploadFile(null);
    setIsUpload(true);
  };

  return (
    <>
      <NewPopup
        trigger={popupCard === "edit"}
        closePopup={handleClosePopup}
        header={"Edit Site Image"}
        backPopup="Cancel"
        backOnClick={handleClosePopup}
        nextpopup={"Save"}
        nextOnClick={siteUploadImage}
        loading={loading}
        disabled={isUpload}
      >
        <ImageUploader
          imagePreview={img}
          loading={deleting}
          onDelete={siteDeleteImage}
          onUploadClick={() => fileInputRef.current.click()}
          onFileChange={handleFileChange}
          fileInputRef={fileInputRef}
        />
      </NewPopup>
    </>
  );
};

export default EditSiteImage;
